import api from "@modules/api/api";
import tradeInQueryKeys from "@modules/trade/types/tradeInQueryKeys";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import userQueryKeys from "../userQueryKeys";

const postLogout = async () => {
  return api.rawPost("api/accounts/sign-out");
};

export default function useLogoutUserMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: postLogout,
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: userQueryKeys.user() }); // forces useUser to refetch user data and thereforce forces components that use useUser to rerender
      queryClient.removeQueries({ queryKey: userQueryKeys.all });
      queryClient.removeQueries({ queryKey: tradeInQueryKeys.all });
    },
  });
}
